import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import styles from "../../../assets/styles/componentStyles/billingStyles/planSubscribedPopup.module.scss";

import GlobalPopUp from "../../utility/globalPopUp";
import GlobalButton from "../../utility/globalButton/button";
import useGenericHook from "../../../hooks/useGenericHook";

interface ChannelDeploymentLimitPopupProps {
    open: boolean;
    onClose: () => void;
}

const ChannelDeploymentLimitPopup = ({ open, onClose }: ChannelDeploymentLimitPopupProps) => {

    const { isScreenBelow600 } = useGenericHook();

    return (
        <GlobalPopUp
            open={open}
            onClose={onClose}
            handleClose={onClose}
            flagShowCloseIcon={true}
            flagBackdrop
            titlePadding="5px"
            borderRadius="16px"
            paperMinWidth={isScreenBelow600 ? "90%" : "550px"}
            paperMaxwidth={isScreenBelow600 ? "350px" : "650px"}
        >
            <Box className={styles.content}>
                <Box className={styles.iconWrap}>
                    <InfoOutlinedIcon className={styles.icon} />
                </Box>

                <Typography className={styles.title}>
                    You cannot switch to this plan
                </Typography>

                <Typography className={`${styles.description} ${styles.descriptionFull}`}>
                    The plan you're trying to switch to doesn't support your current number of connected channels currently associated with your account.
                    Please choose a different plan or reduce the number of connected channels before switching.
                </Typography>

                <Box className={styles.continueBtn}>
                    <GlobalButton
                        buttonText="Manage Channels"
                        className="primaryButtonStyle"
                        onClick={() => { window.location.href = "/channels"; onClose(); }}
                    />
                </Box>
            </Box>
        </GlobalPopUp>
    );
};

export default ChannelDeploymentLimitPopup;
